export default __webpack_public_path__ + "static/media/Sarabun-ExtraLight.1f3e68d6.ttf";